import { Button, Flex, Heading, Highlight, Icon, Image } from "@chakra-ui/react"

import { FaArrowRightLong, FaHandPointRight } from "react-icons/fa6";

import './styles/ContactBanner.css';

function ContactBanner(props: any) {

  return (
    <div>
        {/* Desktop only view */}
        <Flex className="contact_banner__parent" direction='column' gap='8'>
            <Heading color='black' fontWeight='bold' size='5xl'>
                <Highlight query='supercharge' styles={{color:'#FB5383'}}>
                    Ready to supercharge your compensation?
                </Highlight>
            </Heading>
            <Flex direction='column' gap='2' style={{marginTop: '40px'}}>
                <Heading color='#4e4e4e' fontWeight='bold' size='4xl' textAlign='center'>
                    <Highlight query='Did you know?' styles={{color: '#FB5383'}}>
                        Did you know? &nbsp;Most engineers don't negotiate and take the first offer
                    </Highlight>
                </Heading>
                <Heading color='#4e4e4e' fontWeight='bold' size='4xl' textAlign='center'>
                    <Highlight query='Did you know?' styles={{color: '#FB5383'}}>
                        Did you know? &nbsp;Companies won't rescind their offers if you negotiate
                    </Highlight>
                </Heading>
                <Heading color='#4e4e4e' fontWeight='bold' size='4xl' textAlign='center'>
                    <Highlight query='Did you know?' styles={{color: '#FB5383'}}>
                        Did you know? &nbsp;Negotiating your compensation upfront compounds every year after
                    </Highlight>
                </Heading>
            </Flex>
            <Flex justify='center' style={{marginTop: '40px'}}>
                <Button backgroundColor='#FB5383' color='white' className='button' fontWeight='bold' rounded='md' size='lg' onMouseDown={() => {
                    window.location.href='#contactus'
                }}>
                    Supercharge my earnings <FaArrowRightLong style={{height: "15px", width: "15px"}} />
                </Button>
            </Flex>
        </Flex>

        {/* Mobile only view */}
        <Flex className="contact_banner__mobile_parent" direction='column' gap='8'>
            <Heading color='black' fontWeight='bold' size='4xl'>
                <Highlight query='supercharge' styles={{color:'#FB5383'}}>
                    Ready to supercharge your compensation?
                </Highlight>
            </Heading>
            <Flex direction='column' gap='2' style={{marginTop: '40px'}}>
                <Heading color='#4e4e4e' fontWeight='bold' size='2xl' textAlign='center'>
                    <Flex>
                        <Icon style={{marginTop: '5px'}}>
                            <FaHandPointRight/>
                        </Icon>
                        <div>
                            <Highlight query='Did you know?' styles={{color: '#FB5383'}}>
                                Did you know? &nbsp;Most engineers don't negotiate and take the first offer
                            </Highlight>
                        </div>
                    </Flex>
                </Heading>
                <Heading color='#4e4e4e' fontWeight='bold' size='2xl' textAlign='center' style={{marginTop: '15px'}}>
                    <Flex>
                        <Icon style={{marginTop: '5px'}}>
                            <FaHandPointRight/>
                        </Icon>
                        <div>
                            <Highlight query='Did you know?' styles={{color: '#FB5383'}}>
                                Did you know? &nbsp;Companies won't rescind their offers if you negotiate
                            </Highlight>
                        </div>    
                    </Flex>
                </Heading>
                <Heading color='#4e4e4e' fontWeight='bold' size='2xl' textAlign='center' style={{marginTop: '15px'}}>
                    <Flex>
                        <Icon style={{marginTop: '5px'}}>
                            <FaHandPointRight/>
                        </Icon>
                        <div>
                            <Highlight query='Did you know?' styles={{color: '#FB5383'}}>
                                Did you know? &nbsp;Negotiating your compensation upfront compounds every year after
                            </Highlight>
                        </div>
                    </Flex>
                </Heading>
            </Flex>
            <Flex justify='center' style={{marginTop: '25px'}}>
                <Button backgroundColor='#FB5383' color='white' className='button' fontWeight='bold' rounded='md' size='lg' onMouseDown={() => {
                    window.location.href='#contactus'
                }}>
                    Supercharge my earnings <FaArrowRightLong style={{height: "15px", width: "15px"}} />
                </Button>
            </Flex>
        </Flex>
    </div>
  );
}

export default ContactBanner;
